import api from "./api/api.dtes";
import {
  FacturaElectronicaRequest,
  FacturaElectronicaResponse,
  ConsultarFacturaParams
} from "./types/dtes.types";

export const enviarFacturaElectronica = async (
  factura: FacturaElectronicaRequest
): Promise<FacturaElectronicaResponse> => {
  try {
    const response = await api.post<FacturaElectronicaResponse>("/factura/", factura);
    return response.data;
  } catch (error) {
    console.error("Error al enviar factura electrónica:", error);
    throw error;
  }
};

export const consultarFacturaElectronica = async (
  params: ConsultarFacturaParams
): Promise<string> => {
  try {
    const response = await api.get<string>("/factura/consultar/", {
      params: {
        codGeneracion: params.codGeneracion,
        tdte: params.tdte || "01"
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error al consultar factura electrónica:", error);
    throw error;
  }
};
